// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import type { Skin } from '@/theme/skin';
import { alpha } from '@/theme/colors';

/**
 * The web date picker's colours, as the custom properties styles/datepicker.css reads. The
 * stylesheet holds no colours of its own, so this is the only place a skin reaches the picker
 * and the only place __tests__/datePickerColors.test.ts has to check for legibility.
 */
export function datePickerColors(colors: Skin['colors']) {
  return {
    '--goffy-date-bg': colors.surface.input,
    '--goffy-date-border': colors.border.strong,
    '--goffy-date-text': colors.text.primary,
    '--goffy-date-label': colors.text.muted,
    '--goffy-date-muted': colors.text.dim,
    '--goffy-date-accent': colors.accent.primary,
    '--goffy-date-on-accent': colors.text.inverse,
    '--goffy-date-hover': alpha(colors.accent.primary, 0.16),
  };
}
